import { paymentTypeOptions } from 'src/constants';

export const taptapCustomerPaymentMethods = paymentTypeOptions.map(
  (option) => ({ ...option, label: option.name })
);
